import React from "react";

import { Observable } from "../../../../auto/js/events/Observable"
import { record } from "../../Record";
import { createRecord, filterObject, getRecordsOptions, readRecord } from "../../utils";
import { mapNnFieldDto2Form, mapNnFieldForm2Dto } from "../../Widgets/WidgetsFilters";
import AutocompleteDynamicListSelectorField from "../../Widgets/AutocompleteDynamicListSelectorField";
import { formState } from "../../../../auto/js/forms/FormState";
import { update } from "../../../../auto/js/forms/signatureRequest/NewSignatureRequestForm";
import { t } from "../../../../auto/js/services";
import { createTableComponent } from "../../../../auto/js/widgets/TableComponent";
import { displaySignatureRequestList } from "../../../../auto/js/lists/signatureRequest/SignatureRequestList";
import QRCode from "react-qr-code";
import { setNewContext } from "../../lists/signatureRequest/SignatureRequestListCommon";

export const idDisplay = () => {
    return false
}

export const partiesComponentHook = (name, disabled, data, gui) => {
    const signaturePartyListColumns = [
	    {
	        title: "Name",
	        field: "name",
	    },
        {
	        title: "Status",
	        field: "status",
	    },
        {
	        title: "Signature",
	        field: "signatureRecords",
            render: (rowData) => getSignatureRecordQrCode(rowData)
	    },
	];
    const getPartiesData = ({ page, pageSize, search, orderBy, orderDirection }) => {
        let parties = Object.values(data.parties);
        let records = Object.values(data.signatureRecords);
        parties.forEach(party => {
            records.forEach(element => {
                if (element.signaturePartyId === party.eid)
                    party.signatureRecords = element;
            });
        });
        
        if (search) {
			parties = parties.filter(item =>
				Object.values(item).some(val =>
				String(val).toLowerCase().includes(search.toLowerCase())
				)
			);
		}
		if (orderBy) {
			parties = parties.sort((a, b) => {
			  const valA = a[orderBy];
			  const valB = b[orderBy];
			  if (valA === valB) return 0;
			  const comparison = valA > valB ? 1 : -1;
			  return orderDirection === 'desc' ? -comparison : comparison;
			});
		}
        const start = page * pageSize;
		const paginatedResults = parties.slice(start, start + pageSize);
		
		return {data: paginatedResults, totalCount: parties.length, page: page};
    }
    if (data.status !== null) {
        let SignaturePartyTable = createTableComponent(signaturePartyListColumns);
        return (
            <div>
                {t`Parties`}
                <SignaturePartyTable loadData={async (query) => getPartiesData(query)}/>
            </div>
        ) 
    }
    else {
        let observable = new Observable()
        observable.subscribe(readRecord(gui))
        return <AutocompleteDynamicListSelectorField 
            time={1000} 
            observable={observable} 
            createEntry={(data, callback, onCancel) => createRecord(data, callback, gui, onCancel)} 
            searchRequest={async (filter) => getRecordsOptions(filter)}
    //		dataFilter={record.recordObject2String}
            name={name}
            readOnly={disabled} 
            label={t`Parties`} />
    }

}

const getSignatureRecordQrCode = (rowData) => {
    if (rowData.signatureRecords) {
        console.log(extractPGPMessage(rowData.signatureRecords.signedHash))
        return (
            <QRCode value={"E-ID: " + rowData.signatureRecords.signaturePartyId + "\n signature: " + extractPGPMessage(rowData.signatureRecords.signedHash) + "\n name: " + rowData.name} size={100}/>
        )
    }
}

export const customSignatureRequestForm2Dto = (formData) => {
	let fieldFilters = {};
	fieldFilters['parties'] = mapNnFieldForm2Dto;
	let dto = filterObject(formData, fieldFilters);
	return dto;
}

export const customSignatureRequestDto2Form = (dto) => {
	let fieldFilters = {};
    if(dto.status === null)
	    fieldFilters['parties'] = mapNnFieldDto2Form;
	let form = filterObject(dto, fieldFilters);
	return form;
}

export const getContext = (gui, onFinish) => () => {
    return {
        "signature-requests": {
            "requests": {
                submenu: {
                    "actions": {
                        options: {
                                submit: { label: "Submit", do: () => (onFinish)?update(formState.getState().data).then(() => onFinish()):update(formState.getState().data)},

                        },
                        label: "Actions"
                    },
                },
                label: "Signature Requests",
                do: (gui) => {
                    displaySignatureRequestList(gui)
                    setNewContext(gui);
                }
            }
        }
    }
}

function extractPGPMessage(pgpText) {
    const lines = pgpText
      .split('\n')
      .map(line => line.trim())
      .filter(line => 
        line &&
        !line.startsWith('-----BEGIN PGP MESSAGE-----') &&
        !line.startsWith('-----END PGP MESSAGE-----') &&
        !line.startsWith('Version:') &&
        !line.startsWith('Comment:') &&
        !line.startsWith('=')
      );
  
    return lines.join('');
  }